import React, { useEffect, useLayoutEffect } from 'react'
import ConnectedPageSearchContainer from 'redux/containers/pages/search/ConnectedPageSearchContainer'

const Paged = (props) => {
  const {
    searchPhrase,
    setCurrentSearchPhrase,
    searchType,
    pageNumber,
    pageLimit,
    query,
    setSearchState,
    setSearchResponse,
    flavour
  } = props

  useLayoutEffect(() => {
    setSearchState({ pageLimit, pageNumber, paginationMode: 'paged', query, searchPhrase, searchType })
  }, [pageLimit, pageNumber, query, searchPhrase, searchType, setSearchState])

  useEffect(() => {
    setSearchState({ pageLimit, pageNumber, paginationMode: 'paged', query, searchPhrase, searchType })
  }, [flavour])

  useEffect(() => {
    return () => {
      setSearchResponse(null)
      setCurrentSearchPhrase('')
    }
  }, [])

  return <ConnectedPageSearchContainer />
}

export default Paged
